import React from "react";
import { motion } from "framer-motion";
import { SectionBadge, IconQuote, Highlight, FadeUp } from "@/components/BrandKit";

const TESTIMONIAL = {
  paragraphs: [
    "We were at a point where scaling performance creatives the traditional way was starting to feel... repetitive. The need was clear: stay fresh, stay relevant, and move at the speed our consumers make decisions. That's where the collaboration with Big Bear Studios really clicked.",
    "The shift to AI-led videos, powered by their approach, played a big role for us. What we ended up building together was a flexible creative AI engine, one that could adapt to different moments, categories, and moods without losing its edge, and without the usual trade-offs.",
    "As a result, we saw stronger engagement, more efficient spends, and importantly, consistency at scale, which is often the harder part. But beyond metrics, it shifted how we think about creative itself. Less as 'just functional', more as a dynamic growth lever.",
    "What AI can unlock in a performance-first environment is truly exciting. And honestly, it's been a fun ride getting there with the team!",
  ],
  name: "Rahul Doss",
  role: "Director of Growth, Instamart",
  initials: "RD",
};

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="border-b border-black bg-[#FDFBF7]"
    >
      <div className="max-w-[1480px] mx-auto px-5 sm:px-8 py-20 sm:py-24">
        <FadeUp>
          <SectionBadge
            label="Testimonials"
            num="05"
            color="#FF4D00"
            icon={<IconQuote className="w-4 h-4 text-white" />}
          />
        </FadeUp>
        <FadeUp delay={0.08}>
          <h2
            data-testid="testimonials-heading"
            className="mt-5 mb-14 font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight"
            style={{ fontWeight: 900 }}
          >
            Client <Highlight color="#FF4D00">love</Highlight>.
          </h2>
        </FadeUp>

        <motion.figure
          data-testid="testimonial-0"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative rounded-3xl border border-black/5 p-8 sm:p-10 lg:p-14 max-w-5xl"
          style={{
            background:
              "radial-gradient(140% 100% at 15% 100%, #FFE7B0 0%, transparent 55%), radial-gradient(120% 100% at 90% 10%, #FFD7DA 0%, transparent 55%), linear-gradient(180deg, #FFFDF7 0%, #FFF3E0 100%)",
            boxShadow:
              "0 1px 0 rgba(0,0,0,0.02), 0 24px 60px -20px rgba(52,31,101,0.18), 0 8px 24px -14px rgba(0,0,0,0.08)",
          }}
        >
          <div
            className="font-serif-italic text-[#FF4D00] text-[110px] sm:text-[140px] leading-none select-none absolute top-2 sm:top-4 left-6 sm:left-10 pointer-events-none"
          >
            &ldquo;
          </div>

          <blockquote className="relative pt-16 sm:pt-20 space-y-5 sm:space-y-6 max-w-3xl">
            {TESTIMONIAL.paragraphs.map((p, i) => (
              <p
                key={i}
                className={
                  i === 0
                    ? "font-display text-xl sm:text-2xl lg:text-[28px] leading-[1.3] tracking-tight text-black"
                    : "text-[15px] sm:text-base lg:text-[17px] leading-[1.65] text-black/80"
                }
                style={i === 0 ? { fontWeight: 700 } : {}}
              >
                {p}
              </p>
            ))}
          </blockquote>

          <figcaption className="mt-10 pt-6 border-t border-black/15 flex items-center gap-4">
            <span
              className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-black text-white font-display text-sm"
              style={{ fontWeight: 800 }}
            >
              {TESTIMONIAL.initials}
            </span>
            <div>
              <div
                className="font-display uppercase tracking-tight text-lg sm:text-xl leading-none"
                style={{ fontWeight: 900 }}
              >
                {TESTIMONIAL.name}
              </div>
              <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-black/60 mt-1.5">
                {TESTIMONIAL.role}
              </div>
            </div>
          </figcaption>
        </motion.figure>
      </div>
    </section>
  );
}
